var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1214 0.25H9.8351V13.5326C9.8351 15.1152 8.57115 16.4152 6.99821 16.4152C5.42527 16.4152 4.16131 15.1152 4.16131 13.5326C4.16131 11.9783 5.39719 10.7065 6.91397 10.65V7.31523C3.57146 7.37173 0.875 10.113 0.875 13.5326C0.875 16.9805 3.62763 19.75 7.02631 19.75C10.4249 19.75 13.1776 16.9522 13.1776 13.5326V6.72173C14.4135 7.62609 15.9302 8.16305 17.5312 8.19132V4.85652C15.0595 4.77174 13.1214 2.73695 13.1214 0.25Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.5d6e845d.svg";
export { ForwardRef as ReactComponent };